// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAwcY0G7P_nfPmPIunKKaPQOs-2F44DNog",
    authDomain: "iprog-pokemonteambuilder.firebaseapp.com",
    databaseURL: "https://iprog-pokemonteambuilder-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "iprog-pokemonteambuilder",
    storageBucket: "iprog-pokemonteambuilder.firebasestorage.app",
    messagingSenderId: "337626551960",
    appId: "1:337626551960:web:d8115a3c916ac44fbda2ed",
    measurementId: "G-9JXS9STCRW"
};

export { firebaseConfig };